export enum MainCategoryName {
    LIVING_AND_ENERGY = 'LIVING_AND_ENERGY',
    FOOD = 'FOOD',
    HEALTH = 'HEALTH',
    CLOTHING = 'CLOTHING',
    COMMUNICATION = 'COMMUNICATION',
    LEISURE = 'LEISURE',
    EDUCATION = 'EDUCATION',
    CAR = 'CAR',
    TRANSPORT = 'TRANSPORT',
    TRAVEL_HOLIDAYS = 'TRAVEL_HOLIDAYS',
    WITHDRAWAL = 'WITHDRAWAL',
    ALIMONY_POCKET_MONEY = 'ALIMONY_POCKET_MONEY',
    ONLINE_SHOPPING = 'ONLINE_SHOPPING',
    SAVINGS_INVESTMENT = 'SAVINGS_INVESTMENT',
    TAXES = 'TAXES',
    FEES = 'FEES',
    OTHER_EXPENSES = 'OTHER_EXPENSES',
    UNCATEGORIZED_EXPENSE = 'UNCATEGORIZED_EXPENSE',
    REGULAR_INCOME = 'REGULAR_INCOME',
    NON_REGULAR_INCOME = 'NON_REGULAR_INCOME',
    UNCATEGORIZED_INCOME = 'UNCATEGORIZED_INCOME',
}
